module.exports = __webpack_public_path__ + "static/banner-bg-3e9c9afd1816d530267fe07ae608447e.jpg";